/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmSkillsGet } from "../../funcs/llmSkillsGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetSkillRequest$inboundSchema,
};

export const tool$llmSkillsGet: ToolDefinition<typeof args> = {
  name: "llm-skills-get",
  description: `Retrieve skill

Returns information about a specific skill.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmSkillsGet(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
